import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  data() {
    return {
      datacollection: {
        labels: [
          '1/1/2015',
          '6/1/2015',
          '1/1/2016',
          '6/1/2016',
          '1/1/2017',
          '6/1/2017',
        ],
        datasets: [
          {
            label: 'Net Worth',
            backgroundColor: 'rgba(51, 153, 255, 0.20)',
            borderColor: 'rgba(51, 153, 255, 0.90)',
            data: [
              250000,
              255000,
              270000,
              268000,
              279000,
              295000,
            ],
          },
        ],
      },
    };
  },
  mounted() {
    const vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      lineTension: 0,
      tooltips: {
        callbacks: {
          title: tooltipItems => `${tooltipItems[0].xLabel}`,
          label: tooltipItem => `$${tooltipItem.yLabel.toLocaleString('currency')}`,
        },
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: value => `$${value.toLocaleString('currency')}`,
            max: 300000,
            min: 225000,
            stepSize: 25000,
          },
        }],
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/charts/NetWorthChart.js